import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { useTranslation } from "react-i18next";
import Container from "../components/Container";
import usePortfolioStore from "../store/store";
import Loading from "../components/loading";

export default function Certifications() {
  const { colors } = useTheme();
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(true);
  const certifications = usePortfolioStore((s) => s.certifications || []);
  const fetchCertificationsRemote = usePortfolioStore((s) => s.fetchCertificationsRemote);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await fetchCertificationsRemote();
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [fetchCertificationsRemote]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Container>
      <div className="py-8">
        <div className="mb-4 lg:mb-8">
          <h2
            className={`text-lg md:text-2xl lg:text-4xl font-bold ${colors.text.primary}`}
          >
            {t("certifications.title")}
          </h2>
          <p
            className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-1`}
          >
            {t("certifications.description")}
          </p>
        </div>
        {certifications.length === 0 ? (
          <div className={`${colors.background.secondary} rounded-lg p-12 text-center`}>
            <svg className={`mx-auto h-16 w-16 ${colors.text.muted} mb-4`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5z" />
            </svg>
            <p className={colors.text.secondary}>{t("certifications.empty")}</p>
          </div>
        ) : (
          <div className="space-y-2 lg:space-y-4">
            {certifications.map((cert) => (
              <Link
                key={cert.id}
                to={`/certifications/${cert.id}`}
                className={`${colors.background.primary} rounded-lg border ${colors.border} p-3 md:p-5 hover:shadow-lg transition-all block`}
              >
                <div className="flex gap-2 sm:gap-4 md:gap-6">
                  <div className="flex-1">
                    <h3 className={`text-base sm:text-lg md:text-2xl font-semibold mb-1 ${colors.text.primary}`}>{cert.name}</h3>
                    <span className="inline-block bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-200 px-3 py-1 rounded-full text-[11px] sm:text-xs md:text-sm font-medium mb-2">
                      {cert.issuer}
                    </span>
                    <p className={`text-sm sm:text-base md:text-lg ${colors.text.secondary} mb-2`}>{cert.year}</p>
                    {cert.description && (
                      <p className={`${colors.text.secondary} text-[11px] sm:text-xs md:text-sm line-clamp-2`}>{cert.description}</p>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Container>
  );
}
